// Rainbow Six Siege - Operator Roster
// Keep entries minimal: { id, name, unit, role }
// Add new operators by appending to ATTACKERS or DEFENDERS arrays.
// `id` = lowercase slug, used internally. `name` shown in UI.
// Icon lookup (future): /icons/{id}.png - fall back to OperatorEmblem.

export const ATTACKERS = [
  { id: "striker", name: "Striker", unit: "Recruit", role: "Versatile" },
  { id: "sledge", name: "Sledge", unit: "SAS", role: "Breach" },
  { id: "thatcher", name: "Thatcher", unit: "SAS", role: "Anti-Gadget" },
  { id: "ash", name: "Ash", unit: "FBI SWAT", role: "Breach" },
  { id: "thermite", name: "Thermite", unit: "FBI SWAT", role: "Breach" },
  { id: "twitch", name: "Twitch", unit: "GIGN", role: "Anti-Gadget" },
  { id: "montagne", name: "Montagne", unit: "GIGN", role: "Shield" },
  { id: "glaz", name: "Glaz", unit: "Spetsnaz", role: "Marksman" },
  { id: "fuze", name: "Fuze", unit: "Spetsnaz", role: "Anti-Hostage" },
  { id: "iq", name: "IQ", unit: "GSG 9", role: "Anti-Gadget" },
  { id: "blitz", name: "Blitz", unit: "GSG 9", role: "Shield" },
  { id: "buck", name: "Buck", unit: "JTF2", role: "Breach" },
  { id: "blackbeard", name: "Blackbeard", unit: "NAVY SEAL", role: "Front Line" },
  { id: "capitao", name: "Capitão", unit: "BOPE", role: "Area Denial" },
  { id: "hibana", name: "Hibana", unit: "SAT", role: "Breach" },
  { id: "jackal", name: "Jackal", unit: "GEO", role: "Intel" },
  { id: "ying", name: "Ying", unit: "SDU", role: "Disorient" },
  { id: "zofia", name: "Zofia", unit: "GROM", role: "Breach" },
  { id: "dokkaebi", name: "Dokkaebi", unit: "707th SMB", role: "Intel" },
  { id: "lion", name: "Lion", unit: "CBRN", role: "Intel" },
  { id: "finka", name: "Finka", unit: "CBRN", role: "Support" },
  { id: "gridlock", name: "Gridlock", unit: "SASR", role: "Area Denial" },
  { id: "nomad", name: "Nomad", unit: "GIGR", role: "Area Denial" },
  { id: "maverick", name: "Maverick", unit: "GSUTR", role: "Breach" },
  { id: "nokk", name: "Nøkk", unit: "JAEGER CORPS", role: "Covert" },
  { id: "amaru", name: "Amaru", unit: "APCA", role: "Mobility" },
  { id: "kali", name: "Kali", unit: "NIGHTHAVEN", role: "Marksman" },
  { id: "iana", name: "Iana", unit: "REU", role: "Covert" },
  { id: "ace", name: "Ace", unit: "NIGHTHAVEN", role: "Breach" },
  { id: "zero", name: "Zero", unit: "ROS", role: "Intel" },
  { id: "flores", name: "Flores", unit: "UNIDAD ESPECIAL", role: "Anti-Gadget" },
  { id: "osa", name: "Osa", unit: "NIGHTHAVEN", role: "Shield" },
  { id: "sens", name: "Sens", unit: "SFG", role: "Area Denial" },
  { id: "grim", name: "Grim", unit: "NIGHTHAVEN", role: "Intel" },
  { id: "brava", name: "Brava", unit: "COT", role: "Anti-Gadget" },
  { id: "ram", name: "Ram", unit: "GSG 9", role: "Breach" },
  { id: "deimos", name: "Deimos", unit: "WOLFGUARD", role: "Intel" },
  { id: "rauora", name: "Rauora", unit: "NZSAS", role: "Support" },
  { id: "solid_snake", name: "Solid Snake", unit: "FOXHOUND", role: "Covert" },
];

export const DEFENDERS = [
  { id: "sentry", name: "Sentry", unit: "Recruit", role: "Versatile" },
  { id: "smoke", name: "Smoke", unit: "SAS", role: "Area Denial" },
  { id: "mute", name: "Mute", unit: "SAS", role: "Anti-Gadget" },
  { id: "castle", name: "Castle", unit: "FBI SWAT", role: "Support" },
  { id: "pulse", name: "Pulse", unit: "FBI SWAT", role: "Intel" },
  { id: "doc", name: "Doc", unit: "GIGN", role: "Support" },
  { id: "rook", name: "Rook", unit: "GIGN", role: "Support" },
  { id: "kapkan", name: "Kapkan", unit: "Spetsnaz", role: "Trapper" },
  { id: "tachanka", name: "Tachanka", unit: "Spetsnaz", role: "Front Line" },
  { id: "jager", name: "Jäger", unit: "GSG 9", role: "Anti-Gadget" },
  { id: "bandit", name: "Bandit", unit: "GSG 9", role: "Anti-Gadget" },
  { id: "frost", name: "Frost", unit: "JTF2", role: "Trapper" },
  { id: "valkyrie", name: "Valkyrie", unit: "NAVY SEAL", role: "Intel" },
  { id: "caveira", name: "Caveira", unit: "BOPE", role: "Intel" },
  { id: "echo", name: "Echo", unit: "SAT", role: "Anti-Entry" },
  { id: "mira", name: "Mira", unit: "GEO", role: "Intel" },
  { id: "lesion", name: "Lesion", unit: "SDU", role: "Trapper" },
  { id: "ela", name: "Ela", unit: "GROM", role: "Disorient" },
  { id: "vigil", name: "Vigil", unit: "707th SMB", role: "Covert" },
  { id: "maestro", name: "Maestro", unit: "GIS", role: "Front Line" },
  { id: "alibi", name: "Alibi", unit: "GIS", role: "Intel" },
  { id: "clash", name: "Clash", unit: "GSUTR", role: "Shield" },
  { id: "kaid", name: "Kaid", unit: "GIGR", role: "Anti-Gadget" },
  { id: "mozzie", name: "Mozzie", unit: "SASR", role: "Intel" },
  { id: "warden", name: "Warden", unit: "SECRET SERVICE", role: "Covert" },
  { id: "goyo", name: "Goyo", unit: "FES", role: "Area Denial" },
  { id: "wamai", name: "Wamai", unit: "NIGHTHAVEN", role: "Anti-Gadget" },
  { id: "oryx", name: "Oryx", unit: "JORDAN GIS", role: "Mobility" },
  { id: "melusi", name: "Melusi", unit: "INKABA", role: "Intel" },
  { id: "aruni", name: "Aruni", unit: "NIGHTHAVEN", role: "Trapper" },
  { id: "thunderbird", name: "Thunderbird", unit: "STAR-NET", role: "Support" },
  { id: "thorn", name: "Thorn", unit: "EMERALD PLATE", role: "Trapper" },
  { id: "azami", name: "Azami", unit: "UNAFFILIATED", role: "Anti-Entry" },
  { id: "solis", name: "Solis", unit: "AFEAU", role: "Intel" },
  { id: "fenrir", name: "Fenrir", unit: "WOLFGUARD", role: "Disorient" },
  { id: "tubarao", name: "Tubarão", unit: "GRUMEC", role: "Anti-Gadget" },
  { id: "skopos", name: "Skopós", unit: "UNAFFILIATED", role: "Intel" },
  { id: "denari", name: "Denari", unit: "707TH SMB", role: "Support" },
];

export const ALL_OPERATORS = [
  ...ATTACKERS.map((o) => ({ ...o, side: "attacker" })),
  ...DEFENDERS.map((o) => ({ ...o, side: "defender" })),
];

export const getOperators = (side) =>
  side === "attacker" ? ATTACKERS : DEFENDERS;

// ---------------------------------------------------------------------------
// Comp-role definitions for the "Guaranteed Roles" feature.
// Each role maps to a list of operator ids eligible to fill that role.
// One operator can legitimately fulfill multiple roles (e.g., Osa = Shield/Intel).
// Add/edit roles here to update the UI guarantees. Each role needs:
//   { id, label, description, operators: [operator_id...] }
// ---------------------------------------------------------------------------
export const ATTACKER_ROLES = [
  {
    id: "hard_breach",
    label: "Hard Breach",
    description: "Opens reinforced walls & hatches",
    operators: ["thermite", "hibana", "ace", "maverick"],
  },
  {
    id: "support",
    label: "Support / Anti-Gadget",
    description: "Disables defender utility",
    operators: ["thatcher", "twitch", "iq", "kali", "brava", "flores"],
  },
  {
    id: "intel",
    label: "Intel Gatherer",
    description: "Recon & info-gathering",
    operators: ["jackal", "dokkaebi", "lion", "zero", "iana", "nokk", "grim", "deimos", "osa"],
  },
  {
    id: "shield",
    label: "Shield / Entry",
    description: "Front-line entry fragger",
    operators: ["montagne", "blitz", "osa", "sledge", "ash", "buck", "zofia", "ram"],
  },
];

export const DEFENDER_ROLES = [
  {
    id: "anti_breach",
    label: "Anti-Breach",
    description: "Denies hard-breach gadgets",
    operators: ["bandit", "kaid", "mute"],
  },
  {
    id: "intel",
    label: "Intel / Roamer-Killer",
    description: "Tracks & counters attackers",
    operators: ["valkyrie", "maestro", "mozzie", "caveira", "pulse", "solis", "alibi", "echo"],
  },
  {
    id: "trapper",
    label: "Trapper",
    description: "Locks off approach routes",
    operators: ["kapkan", "lesion", "frost", "aruni", "thorn", "ela", "fenrir"],
  },
  {
    id: "anchor",
    label: "Anchor / Support",
    description: "Site holder & support",
    operators: ["smoke", "mute", "rook", "doc", "jager", "tachanka", "goyo", "azami", "tubarao", "castle", "denari"],
  },
];

export const getRoles = (side) =>
  side === "attacker" ? ATTACKER_ROLES : DEFENDER_ROLES;

// ---------------------------------------------------------------------------
// Operator icon mapping. Add entries here as icons are uploaded.
// Key = operator id (must match ATTACKERS/DEFENDERS ids above).
// Value = either a URL string (will be inverted to white) OR an object
//   { url, preserveColor: true } to render the icon in its original colors
//   (useful for colored crossover / guest-operator logos).
// ---------------------------------------------------------------------------
export const OPERATOR_ICONS = {
  // Attackers
  glaz: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/aurbxh04_glaz.svg",
  fuze: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/3upmx8ta_fuze.svg",
  sledge: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/jjr9nyq4_sledge.svg",
  thatcher: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/p2noj678_thatcher.svg",
  blitz: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/f34xr4qv_blitz.svg",
  twitch: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/5ipwvhzj_twitch.svg",
  iq: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/j8pt7m0i_iq.svg",
  montagne: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/7mh4ox4e_montagne.svg",
  ash: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ht07n33k_ash.svg",
  thermite: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/rhvfeafc_thermite.svg",
  capitao: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/k2brqfqe_capitao.svg",
  blackbeard: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/xjvdxy07_blackbeard.svg",
  buck: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/au9cslwv_buck.svg",
  hibana: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/c5v9elhm_hibana.svg",
  jackal: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/o4w0z1v7_jackal.svg",
  ying: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ntutqqv0_ying.svg",
  zofia: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/h39sgm4e_zofia.svg",
  dokkaebi: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ejq52jch_dokkaebi.svg",
  finka: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/9kym887o_finka.svg",
  lion: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/wv5agtv9_lion.svg",
  maverick: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/zpvq3ge5_maverick.svg",
  nomad: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/lg9asac3_nomad.svg",
  gridlock: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/o4yjle3a_gridlock.svg",
  nokk: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/nm8spwfo_nokk.svg",
  amaru: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/34sqaeu2_amaru.svg",
  kali: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/flioruu7_kali.svg",
  iana: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/94xbpvd0_iana.svg",
  ace: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/42xoqd5u_ace.svg",
  zero: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/sqaqukb4_zero.svg",
  flores: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/n5zvbh2r_flores.svg",
  osa: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/trksa9em_osa.svg",
  sens: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/b0ud5mu7_sens.svg",
  grim: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ycq5gva5_grim.svg",
  brava: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/6smf7lmr_brava.svg",
  ram: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ehnw2ngq_ram.svg",
  striker: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ulvovxs8_striker.svg",
  deimos: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/3j9vmjph_deimos.svg",
  rauora: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/es3js51r_rauora.svg",
  solid_snake: {
    url: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/2d2t7j97_IMG_1166.webp",
    preserveColor: true,
  },
  // Defenders
  kapkan: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/td5l4vra_kapkan.svg",
  mute: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/n4iuw12x_mute.svg",
  tachanka: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/vizeiwls_tachanka.svg",
  smoke: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/2lbuu4re_smoke.svg",
  bandit: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/606if79f_bandit.svg",
  jager: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/au8mrove_jager.svg",
  rook: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/e8ix53e5_rook.svg",
  doc: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/uimfw8et_doc.svg",
  castle: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/osi57tgr_castle.svg",
  pulse: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/llehchzu_pulse.svg",
  frost: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ts2rkaox_frost.svg",
  valkyrie: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/dec8qswc_valkyrie.svg",
  caveira: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/p1uirzmn_caveira.svg",
  echo: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/kkerk6tz_echo.svg",
  mira: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/c7y0pvcl_mira.svg",
  lesion: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/u6hdvhp4_lesion.svg",
  vigil: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/zypbxi08_vigil.svg",
  ela: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ve29kivr_ela.svg",
  alibi: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/sj2id7gd_alibi.svg",
  maestro: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/hrdh295w_maestro.svg",
  clash: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/o1ar26sg_clash.svg",
  mozzie: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/b58est4q_mozzie.svg",
  kaid: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/nrifx8cc_kaid.svg",
  goyo: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/h2i6v52v_goyo.svg",
  warden: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/tm6p7fgt_warden.svg",
  wamai: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/5ierhyhx_wamai.svg",
  oryx: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/m0zh7sz6_oryx.svg",
  melusi: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/702qk1gj_melusi.svg",
  aruni: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/zfx5nez0_aruni.svg",
  thunderbird: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/hbxq4faa_thunderbird.svg",
  thorn: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/5k7wssob_thorn.svg",
  azami: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/5q0v6hgx_azami.svg",
  solis: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/hm02u4p1_solis.svg",
  fenrir: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/00v88xd1_fenrir.svg",
  tubarao: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/c4f1y9fn_tubarao.svg",
  sentry: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/rjggw4j1_sentry.svg",
  skopos: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/ww0h1ip0_skopos.svg",
  denari: "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/rdhmzguf_denari.svg",
};
